const HoldingAllotmentStatus = Object.freeze({
    REJECTED: 'REJECTED',
    IN_PROGRESS: 'IN_PROGRESS',
    PENDING: 'PENDING',
    ALLOTTED: 'ALLOTTED',
    ALLOTMENT_EXCEEDS_PROPOSED_AMOUNT: 'ALLOTMENT_EXCEEDS_PROPOSED_AMOUNT'
});

export default HoldingAllotmentStatus;
